/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";
import { useGlobalContext } from "contexts/globalContext";
import { pendingInvitationsExpireTime } from "../../constants/appConstants";
import { bannerPresent } from "helpers/general";

/* Components */
import Content from "./content";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ReactComponent as PendingInvitation } from '../../resources/images/people-dark.svg';


/* Styles */
import styles from "./styles";
import generalStyles from '../../resources/styles/general';


const PendingPeople = (props) => {
  const {
    showPendingInvitationsModal,
    setPendingInvitationsModal,
    pendingInviteResponse,
    pendingInvitations,
    setPending,
    revokeInvite,
    resendInvite,
    isFetching,
    invitationCount,
    expiryDaysCount,
  } = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;
  const generalClasses = generalStyles({ theme });


  const globalContext = useGlobalContext();

  return (
    <Offcanvas
      show={showPendingInvitationsModal}
      onHide={setPendingInvitationsModal}
      placement={'end'}
      className={`${generalClasses.formFields} ${classes.pendingInvitationModal}`}
      style={
        globalContext?.fixedHeaderOffset
          ? { marginTop: `${globalContext.fixedHeaderOffset}px` }
          : undefined
      }
      enforceFocus={true}
      data-testid="offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div className={classes.pendingHeader}>
            <div className={classes.iconWrapper}>
              <PendingInvitation />
            </div>
            <div>
              <div className={classes.titleStyle}>
                <FormattedMessage id="pendinginvitation.title" />
              </div>
              <div className={classes.descriptionStyle}>
                <FormattedMessage
                  id={`pendinginvitations.description.${providerCode}`}
                  values={{ days: expiryDaysCount }}
                />
              </div>
            </div>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Content
          pendingInviteResponse={pendingInviteResponse}
          pendingInvitations={pendingInvitations}
          setPending={setPending}
          revokeInvite={revokeInvite}
          resendInvite={resendInvite}
          isFetching={isFetching}
          showPendingInvitationsModal={showPendingInvitationsModal}
          invitationCount={invitationCount}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default PendingPeople;
